module.exports = __webpack_public_path__ + "media/mastercard.svg";


//////////////////
// WEBPACK FOOTER
// ../assets/media/payment/mastercard.svg
// module id = 3295
// module chunks = 0